export default [
  {
    path: '/pages/property/appFunctionSwitchManage',
    meta: { title: '小程序功能开关' },
    name: '/pages/property/appFunctionSwitchManage',
    component: () => import('@/views/property/appFunctionSwitchManageList.vue')
  }
]
